<p>three-d-object-viewer works!</p>
